// get the next hour forecast for today, or tomorrow if near
export function getNextForecast(locationData) {
  if (locationData.first().get('forecasts').size > 0) {
    return locationData.first().get('forecasts').first()
  }

  return locationData.rest().first().get('forecasts').first()
}
